<template>
    <!-- Busca sem resultado no novo layout (2026-09-13, "vamos dar uma modernizada também na busca
         vazia"): card branco, lupa numa bolha, título curto, uma frase e "Limpar busca", que volta
         para a lista sem filtros (a query some e a lista recarrega). Substitui o glyphicon de aviso
         cinza gigante com "Nenhuma transportadora foi encontrada!". -->
    <b-card
        class="mt-2"
        body-class="busca-vazia text-center"
    >
        <div class="bolha-busca mx-auto">
            <i class="fa fa-search" />
        </div>
        <h5 class="titulo-busca">
            {{ titulo }}
        </h5>
        <p class="text-muted mb-3">
            {{ descricao }}
        </p>
        <b-button
            variant="outline-primary"
            @click="limpar"
        >
            Limpar busca
        </b-button>
    </b-card>
</template>
<script>
export default {
    name: 'BuscaVazia',
    props: {
        titulo: {
            type: String,
            default: 'Nenhum registro encontrado'
        },
        descricao: {
            type: String,
            default: 'Confira o termo digitado ou limpe os filtros para ver a lista inteira.'
        }
    },
    methods: {
        limpar() {
            this.$emit('limpar')
            this.$router.push({ path: this.$route.path }).catch(() => {})
        }
    }
}
</script>
<style lang="scss" scoped>
.busca-vazia {
    padding: 40px 24px 32px;
}
.bolha-busca {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: var(--cinza-superficie, #f7f7f7);
    border: 1px solid var(--cinza-borda, #dee2e6);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    i {
        font-size: 28px;
        color: #6c757d;
    }
}
.titulo-busca {
    font-weight: 600;
    margin-bottom: 6px;
}
</style>
